import { IconName } from 'ui/components'

import * as SC from './styles'

type Props = {
  url?: string
  onClick?: () => void
}

export const HistoryItem = (props: Props) => {
  const { url, onClick } = props

  return (
    <SC.HistoryItem
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
      data-qa={`table-action-HISTORY`}
    >
      <SC.WrappedIcon name={IconName.CLOCK_TIME_OUTLINE} />
      <span>History</span>
    </SC.HistoryItem>
  )
}
